import type { RouteObject } from "react-router-dom";
import CreateSandboxClass from "@/pages/sandbox/CreateSandboxClass";
import CreateSandboxInstance from "@/pages/sandbox/CreateSandboxInstance";
import CreateSandboxInstanceFromClass from "@/pages/sandbox/CreateSandboxInstanceFromClass";
import EditSandboxClass from "@/pages/sandbox/EditSandboxClass";
import EditSandboxInstance from "@/pages/sandbox/EditSandboxInstance";
import SandboxClassDetail from "@/pages/sandbox/SandboxClassDetail";
import SandboxInstanceDetail from "@/pages/sandbox/SandboxInstanceDetail";
import Sandboxes from "@/pages/sandbox/Sandboxes";


// TODO(perf): lazy-load these non-first-screen pages with a shared, accessible Suspense fallback.
export const sandboxRoutes: RouteObject[] = [
  { path: "/plugins/sandboxes", element: <Sandboxes /> },
  {
    path: "/plugins/sandboxes/create-class",
    element: <CreateSandboxClass />,
  },
  {
    path: "/plugins/sandboxes/classes/:uid",
    element:<SandboxClassDetail />,
  },
  {
    path: "/plugins/sandboxes/classes/:id/edit",
    element: <EditSandboxClass />,
  },
  {
    path: "/plugins/sandboxes/create-instance",
    element: <CreateSandboxInstance />,
  },
  {
    path: "/plugins/sandboxes/create-instance-from-class/:uid",
    element: <CreateSandboxInstanceFromClass />,
  },
  {
    path: "/plugins/sandboxes/instances/:id",
    element: <SandboxInstanceDetail />,
  },
  {
    path: "/plugins/sandboxes/instances/:id/edit",
    element: <EditSandboxInstance />,
  },
];
